var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("您访问的页面暂不可用")])}
var staticRenderFns = []

export { render, staticRenderFns }